/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M17.9222.6421c-.3168-.8561-1.5276-.8561-1.8444 0l-1.3112 3.5435a.9836.9836 0 0 1-.581.581l-3.5435 1.3111c-.8561.3168-.8561 1.5278 0 1.8445l3.5435 1.3112a.9836.9836 0 0 1 .581.581l1.3112 3.5435c.3168.8561 1.5276.8561 1.8444 0l1.3112-3.5435a.9836.9836 0 0 1 .581-.581l3.5435-1.3111c.8561-.3168.8561-1.5278 0-1.8445l-3.5435-1.3113a.9836.9836 0 0 1-.581-.581L17.9222.6422ZM9.4379 12.5345c-.3222-.8706-1.5535-.8706-1.8757 0l-.388 1.0487a1 1 0 0 1-.5909.5909l-1.0488.388c-.8706.3222-.8706 1.5536 0 1.8757l1.0488.3881a1 1 0 0 1 .5908.5908l.3881 1.0488c.3222.8706 1.5535.8706 1.8757 0l.388-1.0488a1.0001 1.0001 0 0 1 .5909-.5908l1.0487-.3881c.8707-.3221.8707-1.5535 0-1.8757l-1.0487-.388a1 1 0 0 1-.5908-.5909l-.3881-1.0487ZM1.75 9c0-4.004 3.246-7.25 7.25-7.25h3a.75.75 0 0 0 0-1.5H9C4.1675.25.25 4.1675.25 9v6c0 4.8325 3.9175 8.75 8.75 8.75h6c4.8325 0 8.75-3.9175 8.75-8.75v-3a.75.75 0 0 0-1.5 0v3c0 4.0041-3.2459 7.25-7.25 7.25H9c-4.004 0-7.25-3.2459-7.25-7.25V9Z"
    clipRule="evenodd"
  />,
  'MenuAIServiceFilled'
);
